var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplanationBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 888,
    height: 708,
    viewBox: "0 0 888 708",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_245_459410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0001 19L39.0001 11L47.0001 19H121L129 11L137 19H211L219 11L227 19H301L309 11L317 19H391L399 11L407 19H481L489 11L497 19H571L579 11L587 19H661L669 11L677 19H751L759 11L767 19H841L849 11L857 19H869V31L877 39L869 47V121L877 129L869 137V211L877 219L869 227V301L877 309L869 317V391L877 399L869 407V481L877 489L869 497V571L877 579L869 587V661L877 669L869 677V689H857L849 697L841 689H767L759 697L751 689H677L669 697L661 689H587L579 697L571 689H497L489 697L481 689H407L399 697L391 689H317L309 697L301 689H227L219 697L211 689H137L129 697L121 689H47L39 697L31 689H19L19 677L11 669L19 661L19 587L11 579L19 571L19 497L11 489L19 481L19 407L11 399L19 391L19 317L11 309L19 301L19 227L11 219L19 211L19 137L11 129L19 121L19 47L11 39L19 31L19 19H31.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0001 19L39.0001 11L47.0001 19H121L129 11L137 19H211L219 11L227 19H301L309 11L317 19H391L399 11L407 19H481L489 11L497 19H571L579 11L587 19H661L669 11L677 19H751L759 11L767 19H841L849 11L857 19H869V31L877 39L869 47V121L877 129L869 137V211L877 219L869 227V301L877 309L869 317V391L877 399L869 407V481L877 489L869 497V571L877 579L869 587V661L877 669L869 677V689H857L849 697L841 689H767L759 697L751 689H677L669 697L661 689H587L579 697L571 689H497L489 697L481 689H407L399 697L391 689H317L309 697L301 689H227L219 697L211 689H137L129 697L121 689H47L39 697L31 689H19L19 677L11 669L19 661L19 587L11 579L19 571L19 497L11 489L19 481L19 407L11 399L19 391L19 317L11 309L19 301L19 227L11 219L19 211L19 137L11 129L19 121L19 47L11 39L19 31L19 19H31.0001Z",
    stroke: "#3A4682",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_245_459410",
    x: 0.292969,
    y: 0.292969,
    width: 887.414,
    height: 707.414,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_245_459410"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_245_459410",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplanationBorder);
export default __webpack_public_path__ + "static/media/explanation-border.2735f5f26cc53387eb9d8a6e80c48fd8.svg";
export { ForwardRef as ReactComponent };